import React from "react";
import {
  PRELOAD_NOTIFICATION_LINK,
  preloadNotificationLead,
} from "@/helpers/pastClientHomes";
import "./PastClientPreloadNotification.scss";

const PastClientPreloadNotification = ({
  notification,
  timeLabel,
  onOpen,
  onDelete,
}) => (
  <div
    className="notification-sec position-relative notify-info-bg pointer past-client-preload-notification"
    role="button"
    tabIndex={0}
    onClick={onOpen}
    onKeyDown={(e) => {
      if (e.key === "Enter") onOpen();
    }}
  >
    <button
      type="button"
      className="btn notif-delete-btn"
      aria-label="Delete notification"
      onClick={(e) => {
        e.stopPropagation();
        onDelete();
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M4 6.5h16M9.5 6.5V4.75h5V6.5M6.5 6.5l.9 12.6a1.5 1.5 0 0 0 1.5 1.4h6.2a1.5 1.5 0 0 0 1.5-1.4l.9-12.6M10.25 10v6.5M13.75 10v6.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
    <div className="outer-property-wrap pl-20 pr-20 pt-12 pb-12">
      <div className="d-flex mb-0 flex-grow-1 align-items-center">
        <div className="pcpn-icon flex-shrink-0" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1v-9.5Z"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="introduction-content flex-grow-1 ml-10 pe-0 ps-0 pb-0">
          <p className="mb-0 notification-head">
            {preloadNotificationLead(notification?.HomeCount)}{" "}
            <a
              href={void 0}
              onClick={(e) => {
                e.stopPropagation();
                onOpen();
              }}
            >
              {PRELOAD_NOTIFICATION_LINK}
            </a>{" "}
            <span className="time-stamp">{timeLabel}</span>
          </p>
        </div>
      </div>
      {notification?.Read_Status == 1 && (
        <div className="dot-indicator dot-bg-red align-self-center mt-0"></div>
      )}
    </div>
  </div>
);

export default PastClientPreloadNotification;
